export const passwordValidationPattern = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!#$()@€?{}|*+,^.\-+&=%_:;~])[a-zA-Z0-9!#$()@€?{}|*+,^.\-+&=%_:;~]{8,40}$/
